import { createPinia } from 'pinia'
import { createApp } from 'vue'

import LoadStyles from '../src/mixins/LoadStyles/LoadStyles'

import hotelheaderlite from '../src/components/HotelHeaderLite/HotelHeaderLite'

import('../fastbooking/vue_fastbooking')

const BASE_ID_SELECTOR = '#vue-hotel-header-lite'

function init() {
  if (!document.querySelector(BASE_ID_SELECTOR)) return

  const app = createApp({
    el: BASE_ID_SELECTOR,
    // Root components must be imported in lowercase
    components: {
      hotelheaderlite,
    },
  })

  app.use(createPinia())

  // i18n global variable
  app.provide('i18n', JSON.parse(document.querySelector(BASE_ID_SELECTOR).dataset.i18n))

  /**
   * TODO: Use Composables instead of Mixins
   * https://vuejs.org/api/options-composition.html#mixins
   * https://vuejs.org/guide/reusability/composables.html
   */
  app.mixin(LoadStyles)
  app.mount(BASE_ID_SELECTOR)
}

init()
